import { connect } from 'react-redux'
import { replace, goBack } from 'react-router-redux'
import at from 'lodash/at'
import debounce from 'lodash/debounce'
import moment from 'moment'
import 'moment-timezone'
import WorkOrdersCreateEdit from '../../components/work-orders/work-orders-create-edit'

import { createWorkOrder } from '../../actions/work-orders'
import { fetchTechniciansForLocationWithAllocation } from '../../actions/technicians'

import { fetchContractsForLocation } from '../../actions/contracts'

const roundThisTime = (datetime) => moment(datetime).set('minute', Math.ceil(moment(datetime).minute() / 5) * 5)
const roundedTime = moment().set('minute', Math.ceil(moment().minute() / 5) * 5)

function mapStateToProps (state, ownProps) {
  const contact = state.auth.session.userName

  const {
    start,
    end,
  } = ownProps.location.query

  const startsAt = start ? roundThisTime(start) : roundedTime
  const endsAt = end ? roundThisTime(end) : start ? roundThisTime(start).clone().add(9, 'hours') : roundedTime.clone().add(9, 'hours')

  return {
    modalTitle: 'Add Work Order',
    submitButtonText: 'Add',
    useAllLocations: true,
    locations: state.allLocations,
    technicians: at(state.users, state.technicians),
    showAutoRenew: true,
    initialValues: {
      startsAt,
      endsAt,
      autoRenew: false,
      autoRenewInterval: 'weekly',
      contact,
      showInputted: false,
    },

    getLocationContact (locationId) {
      return state.allLocations[locationId].mainContact || ''
    },

    getLocationContactPhone (locationId) {
      return state.allLocations[locationId].mainContactPhone || ''
    },

    getLocationDefaultWorkOrderDescription (locationId) {
      return state.allLocations[locationId].defaultWorkOrderDescription || ''
    },

    getLocationContracts (locationId) {
      if (!state || !locationId) return null
      const { finishedLoadingContracts = false } = state.allLocations[locationId] || {}
      if (!finishedLoadingContracts) return null
      return at(state.contracts, state.allLocations[locationId].contracts || [])
    },

    getLocationCanShowInputted (locationId) {
      return state.allLocations[locationId].showInputtedWorkOrders || false
    }
  }
}

function mapDispatchToProps (dispatch) {

  let locationId, dateRange
  const debouncedSearch = debounce(
    () => {
      dispatch(fetchTechniciansForLocationWithAllocation(locationId, dateRange))
    }
    , 750
  )

  return {
    fetchTechniciansForLocationWithAllocation (_locationId, _dateRange) {
      locationId = _locationId
      dateRange = _dateRange
      debouncedSearch()
    },

    fetchContractsForLocation (locationId) {
      dispatch(fetchContractsForLocation(locationId))
    },

    onSubmit (data) {
      data = {
        ...data,
        timezone: moment.tz.guess()
      }

      let renew = null

      if (data.autoRenew) {
        renew = {
          interval: data.autoRenewInterval,
          end_date: data.autoRenewEndDate.toISOString()
        }
      }

      return dispatch(createWorkOrder(data, renew))
      .then((action) => {
        if (action) {
          return action.error && Promise.reject({ _error: action.payload.errors[0] })
        } else {
          return false
        }
      })
        .then(action => dispatch(goBack()))
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrdersCreateEdit)



// WEBPACK FOOTER //
// ./src/containers/work-orders/work-orders-create-container.js